export default {
  methods: {
    gtag() {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer.push(arguments);
    },
  },
};
